"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.paginationTheme = void 0;
var _designTokens = require("@smartsheet/design-tokens");
var _designTokensReact = require("@smartsheet/design-tokens-react");
var _sdsThemeInternal = require("@smartsheet/sds-theme-internal");
var _spacing = require("../../constants/spacing");
const paginationTheme = (0, _sdsThemeInternal.themed)({
  container: {
    padding: {
      "lodestar-light": "0 6px",
      "ursa-light": `${_spacing.sizes.xxSmall}px`
    },
    height: {
      "lodestar-light": "40px",
      "ursa-light": "36px"
    },
    borderRadius: {
      "lodestar-light": _designTokens.border.radius10,
      "ursa-light": _designTokens.border.radius30
    },
    boxShadow: {
      "lodestar-light": "0px 8px 24px rgba(0, 0, 0, 0.12)",
      "ursa-light": (0, _designTokensReact.color)("elevation--shadow-1")
    },
    background: (0, _designTokensReact.color)("color--background--surfaces--work"),
    space: {
      "lodestar-light": "small",
      "ursa-light": "xxSmall"
    }
  },
  text: {
    padding: {
      "lodestar-light": "0px",
      "ursa-light": `0 ${_spacing.sizes.xSmall}px`
    },
    variant: {
      "lodestar-light": "bodyText",
      "ursa-light": "Inter--14px--500w"
    }
  },
  iconButton: {
    width: {
      "lodestar-light": "",
      //size overrides this style
      "ursa-light": "28px"
    },
    height: {
      "lodestar-light": "",
      //size overrides this style
      "ursa-light": "28px"
    },
    size: {
      "lodestar-light": "medium",
      "ursa-light": "small"
    },
    appearance: {
      "lodestar-light": "borderless",
      "ursa-light": "secondary-empty"
    }
  }
});
exports.paginationTheme = paginationTheme;
//# sourceMappingURL=paginationTheme.js.map